module.exports = __webpack_public_path__ + "static/media/sample-collection.3607f61a.webp";